import yelloImage from '../../assets/score/score_back_yellow.png';
import redImage from '../../assets/score/score_back_red.png';
import greenImage from '../../assets/score/score_back_green.png';
import './Changecolor.css';

export const TicketScore = ({ kpiscore }) => {
    let color = '';
    let icon = '';

    if (kpiscore === undefined || kpiscore === null || kpiscore === '') {
        return null;
    }

    if (kpiscore < 60) {
        color = '#e40b0b';
        icon = redImage;
    } else if (kpiscore >= 60 && kpiscore < 90) {
        color = '#fcf300';
        icon = yelloImage;
    } else if (kpiscore >= 90 && kpiscore <= 100) {
        color = '#80ff00';
        icon = greenImage;
    } else {
        color = '#80ff00';
        icon = greenImage;
    }

    return (
        <div className="imgBox">
            <img 
                src={icon} 
                alt="score background" 
                className='ScoreImg' 
                style={{ width: "50px", height: "50px" }}  
            />
            <span className="scoreText" style={{ color }}>
                {kpiscore < 0 ? 0 : kpiscore}
            </span>
        </div>
    );
};
